import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNewNavigationOnboarding } from '../AppLayout/MasterLayout/NewNavigationOnboardingContext';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Dialog as MuiDialog,
  SvgIcon,
  Typography,
} from '@mui/material';
import { customSizes, palette, spaces } from '../../assets/styles/themes/tokens';
import getMuiIcon from '../../utils/getMuiIcon';

interface NewNavigationOnboardingDialogProps {
  open: boolean;
}

const NewNavigationOnboardingDialog = ({ open }: NewNavigationOnboardingDialogProps) => {
  const { t } = useTranslation();
  const onboardingStepCounter = useNewNavigationOnboarding();

  const shouldShow = onboardingStepCounter.showWalkthrough && !onboardingStepCounter.step && open;

  return (
    <MuiDialog
      data-testid='new-navigation-onboarding-dialog'
      open={!!shouldShow}
      onClose={onboardingStepCounter.dismissWalkthrough}
      sx={{
        '& .MuiDialog-paper': {
          width: customSizes.newNavigationOnboarding.dialog.width,
          padding: `${spaces.md} ${spaces.lg} ${spaces.lg} ${spaces.lg}`,
        }
      }}
    >
      <DialogTitle sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: 0
      }}>
        {t('Welcome to the new navigation!')}
        <IconButton
          color='secondary'
          aria-label='close'
          data-testid='dialog-dismiss-button'
          onClick={onboardingStepCounter.dismissWalkthrough}
          sx={{
            marginLeft: spaces.md,
            padding: 0,
          }}
        >
          <SvgIcon component={getMuiIcon('close')} sx={{
            color: palette.text.secondary,
          }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{
        marginTop: spaces.xs,
        paddingBottom: spaces.md,
        paddingX: 0,
      }}>
        <Typography variant='body2'>
          {/* eslint-disable-next-line max-len */}
          {t('You can now find the navigation here. This way you can get to your favorite features faster and easier.')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{
        flexDirection: 'column',
        paddingX: 0,
        paddingBottom: 0,
        paddingTop: spaces.lg,
        margin: 0,
      }}>
        <Button
          onClick={onboardingStepCounter.startOnboarding}
          variant='contained'
          color='primary'
          fullWidth
          size='large'
          sx={{ marginBottom: spaces.xs }}
        >
          {t('Make a tour')}
        </Button>
      </DialogActions>
    </MuiDialog>
  );
};

export default NewNavigationOnboardingDialog;
